export default {
  meta: {
    title: '竞品对比',
    url: '/recommend/contrast', // 埋点用，记录所属模块
  },
};
